var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-just-icon md-danger md-simple text-right",staticStyle:{"margin-right":"10px"},attrs:{"title":"Delete"},on:{"click":function($event){return _vm.deleteMeter()}}},[_c('md-icon',[_vm._v("close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }